import { useAppSelector } from "../Hooks/reduxHook";
import { selectIsAuthenticated } from "../Features/slice/userSlice";
import { Authenticated } from "./Authenticated";
import { UnAuthenticated } from "./UnAuthenticated";

export default function AppRoutes() {
  
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return isAuthenticated ? <Authenticated /> : <UnAuthenticated />;
}
